module.exports = __webpack_public_path__ + "static/pl-product-hero-background_mobile-c94ca2d5e219798e3cf02adf3de6743c.jpg";